import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { ApplyPurePipe } from ':shared/pipes/apply-fn.pipe';

export interface MenuSelectOption {
    value: any;
    viewValue: string;
}

@Component({
    selector: 'app-menu-select',
    templateUrl: './menu-select.component.html',
    styleUrls: ['./menu-select.component.scss'],
    imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, ApplyPurePipe],
})
export class MenuSelectComponent {
    @Output() selectionChange = new EventEmitter();
    @Input() currentOption: string | null = null;
    @Input() options: MenuSelectOption[] = [];
    @Input() compareOptions: (o1: any, o2: any) => boolean = (o1: any, o2: any) => o1 === o2;
    @Input() displaySelectedOption: (currentSelectedOption: any) => any = (option) => option;

    change(event: unknown): void {
        this.selectionChange.emit(event);
    }
}
